var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":'comp-chart-'+_vm.id}},[_c('rect',{staticClass:"swatch",attrs:{"x":"0","y":"0","fill":"white"}}),_vm._v(" "),_c('text',{staticClass:"tooltipt",attrs:{"x":"3","y":"0"}}),_vm._v(" "),_c('rect',{staticClass:"borderr",attrs:{"x":"0","width":"100%","fill":"#e5e5e5"}}),_vm._v(" "),_c('g',{staticClass:"blocksg"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0058510f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/CompGraph.vue
// module id = aOIe
// module chunks = 1